var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"pr-4 mt-2",attrs:{"tabindex":"-1","color":_vm.badge.color ? _vm.badge.color : 'primary',"href":_vm.badge.url}},on),[_vm._v(" "+_vm._s(_vm.badge.title)+" ")])]}}],null,false,3545063602)},[_vm._v(" "+_vm._s(_vm.badge.mouseover)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }